import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router'
import ManageNav from '@/src/components/layout/ManageNav'
import { useAuth } from '@/src/components/AuthContextProvider'
import { SpinnerOverlay } from '@/src/components/SpinnerOverlay'
import { useEffect, useState } from 'react'
import { ListIcon, XIcon } from '@phosphor-icons/react'

export const Route = createFileRoute('/_manage')({
  beforeLoad: async ({ context }) => {
    // Check if user is authenticated
    // This will be handled by the auth context
    // For now, we'll allow access and let components handle auth state
  },
  component: ManageLayout,
})

function ManageLayout() {
  const { status, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)

  useEffect(() => {
    if (status === 'loading') return

    if (!isAuthenticated) {
      const callbackUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
      window.location.href = `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`
      return
    }
  }, [status, isAuthenticated, navigate])

  useEffect(() => {
    setIsMobileNavOpen(false)
  }, [location.pathname])

  if (status === 'loading') {
    return <SpinnerOverlay text="Checking access..." />
  }

  if (!isAuthenticated) {
    return null
  }

  return (
    <div className="flex w-full min-h-screen">
      <button
        type="button"
        className="sm:hidden fixed left-3 z-50 h-10 w-10 rounded-md border border-input bg-background/95 backdrop-blur flex items-center justify-center"
        style={{ top: 'calc(env(safe-area-inset-top) + 3.25rem)' }}
        onClick={() => setIsMobileNavOpen((prev) => !prev)}
        aria-label={isMobileNavOpen ? 'Close manage menu' : 'Open manage menu'}
      >
        {isMobileNavOpen ? <XIcon className="h-5 w-5" /> : <ListIcon className="h-5 w-5" />}
      </button>

      {isMobileNavOpen && (
        <button
          type="button"
          aria-label="Close menu overlay"
          className="sm:hidden fixed inset-0 z-40 bg-black/40"
          onClick={() => setIsMobileNavOpen(false)}
        />
      )}

      <aside
        className={`sm:hidden fixed top-0 left-0 z-50 h-screen w-64 max-w-[85vw] bg-background border-r border-input p-2 overflow-y-auto transition-transform duration-200 ${
          isMobileNavOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="pt-[calc(env(safe-area-inset-top)+3rem)]">
          <ManageNav showLabels={true} />
        </div>
      </aside>

      <aside className="hidden sm:block sticky top-0 transition-all w-12 lg:w-50 mr-2 shrink-0 scrollbar-thin scrollbar-thumb-muted scrollbar-track-transparent">
        <ManageNav />
      </aside>
      <main className="flex-1 bg-background min-w-0">
        <div className="w-full pl-2 pt-14 sm:pt-0">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
